export const isBrazilianPhone = (ddi: string) => {
  return ddi === '+55';
};
